/**
 * Microsoft Entra ID (Azure AD) SSO Configuration
 * 
 * PLACEHOLDER CONFIGURATION
 * Replace these values with your Azure App Registration credentials:
 * 
 * 1. Go to Azure Portal → Azure Active Directory → App Registrations
 * 2. Create a new registration or select existing one
 * 3. Copy Application (client) ID → REACT_APP_AZURE_AD_CLIENT_ID
 * 4. Configure redirect URI as: {your-domain}/sso/callback
 * 5. Create client secret → AZURE_AD_CLIENT_SECRET (backend only)
 */

import { API_BASE } from './api';

export const EntraIdConfig = {
  // Whether Entra ID SSO is enabled (placeholder mode by default)
  enabled: process.env.REACT_APP_AZURE_AD_ENABLED === 'true',
  
  // Azure App Registration Client ID
  // Placeholder: 00000000-0000-0000-0000-000000000000
  clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || '00000000-0000-0000-0000-000000000000',
  
  // Check if using placeholder configuration
  isPlaceholder: () => {
    const clientId = EntraIdConfig.clientId;
    return !clientId || 
           clientId === '00000000-0000-0000-0000-000000000000' ||
           clientId.startsWith('placeholder');
  },
  
  // Microsoft Entra ID endpoints
  authority: 'https://login.microsoftonline.com',
  
  // Common tenant allows users from any Azure AD tenant
  // For single-tenant apps, use your specific tenant ID
  tenantId: 'common',
  
  // OAuth 2.0 scopes for Microsoft Graph
  scopes: ['openid', 'profile', 'email'],
  
  // Redirect URI after authentication (frontend handles callback)
  redirectUri: `${API_BASE}/api/sso/callback/azure`,
  
  // API endpoint for initiating SSO
  initiateEndpoint: '/api/sso/login',
  
  // API endpoint for SSO callback processing
  callbackEndpoint: '/api/sso/callback/azure',
};

/**
 * Build the Microsoft Entra ID authorization URL
 * This is handled by the backend, but useful for reference
 */
export const buildEntraIdAuthUrl = (email, state) => {
  const params = new URLSearchParams({
    client_id: EntraIdConfig.clientId,
    response_type: 'code',
    redirect_uri: EntraIdConfig.redirectUri,
    response_mode: 'query',
    scope: EntraIdConfig.scopes.join(' '),
    state: state,
    login_hint: email,
  });
  
  return `${EntraIdConfig.authority}/${EntraIdConfig.tenantId}/oauth2/v2.0/authorize?${params.toString()}`;
};

/**
 * Validate if email domain is likely an enterprise domain
 */
export const isEnterpriseDomain = (email) => {
  if (!email || !email.includes('@')) return false;
  
  const domain = email.split('@')[1].toLowerCase();
  
  // Common personal email domains (not enterprise)
  const personalDomains = [
    'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 
    'live.com', 'icloud.com', 'aol.com', 'protonmail.com',
    'mail.com', 'zoho.com', 'yandex.com', 'gmx.com'
  ];
  
  return !personalDomains.includes(domain);
};

export default EntraIdConfig;
